import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { map } from 'rxjs';

import { CardVerificationFacade } from '../state/facades/card';

export const CardGuard: CanActivateFn = () => {
  const facade = inject(CardVerificationFacade);
  const router = inject(Router);

  return facade.card$.pipe(
    map(({ card }) => !!card || router.createUrlTree(['profile'])),
  );
};
